import React, { useEffect, useState } from "react";
import AdvancementRequitementField from "../AdvancementRequirementField";
import { Button, Col, Form, Row } from "antd";
import Title from "antd/lib/typography/Title";
import Text from "antd/lib/typography/Text";
import styles from "./index.module.scss";
import { filesCategoriesService } from "@frontend/src/core/services/files_categories_service";

const name = "applicant_requirements";
let id = 0;

const AdvancementRequirements = ({ form, initialValues }) => {
  const initValues = initialValues?.applicant_requirements || [];
  const [fileCategories, setFileCategories] = useState([]);
  const fields =
    form.getFieldValue(name) || Array.from(Array(initValues.length).keys());

  useEffect(() => {
    fetchFileCategories();
  }, []);

  const fetchFileCategories = () => {
    filesCategoriesService.allFilesCategories(
      (data) => {
        setFileCategories(data);
      },
      () => {}
    );
  };

  const add = () => {
    if (fields.length > 0)
      id = fields.length
    const keys = form.getFieldValue(name);
    const nextKeys = keys.concat(id++);
    
    form.setFieldsValue({
      [name]: nextKeys,
    });
  };

  const remove = (k) => {
    const keys = form.getFieldValue(name);
    form.setFieldsValue({
      [name]: keys.filter((key) => key !== k),
    });
  };

  form.getFieldDecorator(name, {
    initialValue: Array.from(Array(initValues.length).keys()),
  });

  return (
    <div className="advancement-requirements">
      <Title className={styles.title}>
        Requisitos de avance
      </Title>
      <Text>
        Al añadir requisitos de avance a las etapas del proceso, podrás permitir
        que los candidatos que cumplan con estos puedan avanzar a la siguiente
        etapa.{" "}
      </Text>
      <div className={styles.advancementRequitementFields}>
        {fields.map((value, index) => (
          <div key={index} className={styles.containerField}>
            <AdvancementRequitementField
              form={form}
              identifier={value}
              initialValues={
                initValues.length > index ? initValues[index] : null
              }
              remove={() => remove(value)}
              fileCategories={fileCategories}
            />
          </div>
        ))}
        <Form.Item>
          <Button className="custom-button-postulation" onClick={add}>
            + Añadir requisito
          </Button>
        </Form.Item>
      </div>
    </div>
  );
};

export default AdvancementRequirements;
